import { Button } from '../common'
import { OrderedItemsForTestWindow } from '.'
import { selectExamDateRefData } from '../../selectors/examWindows'
import { DISPLAY_STATUS } from '../../constants/ApprovalRequestConstants'

const mapStateToProps = state => {
  return { examDateRefData: selectExamDateRefData(state) }
}

export default connect(mapStateToProps)(
  ({ item: { name, status, lastUpdated, reshipmentOrders }, examDateRefData }) => {
    const [open, setOpen] = useState(false)

    const handleClick = () => {
      setOpen(!open)
    }

    return (
      <div
        style={{
          backgroundColor: '#fff',
          border: '5px solid #ccc',
          padding: '5px',
          marginBottom: '8px',
        }}
      >
        <div style={{ backgroundColor: '#eee', border: '1px solid #ccc', padding: '8px' }}>
          <div style={{ display: 'flex' }}>
            <div>
              <h4>{name}</h4>
              <div>{DISPLAY_STATUS[status]}</div>
              <div>Last Modified: {lastUpdated}</div>
            </div>
            <Button
              style={{ marginLeft: 'auto', borderColor: '#eee', backgroundColor: '#fff' }}
              onClick={handleClick}
            >
              {open ? (
                <span className="cb-glyph cb-minus" style={{ fontSize: '1.5em' }} />
              ) : (
                <span className="cb-glyph cb-plus" style={{ fontSize: '1.5em' }} />
              )}
            </Button>
          </div>
          {open ? (
            <>
              {examDateRefData.map(examDateType => (
                <OrderedItemsForTestWindow
                  testWindow={examDateType}
                  orderedItems={reshipmentOrders[examDateType]}
                />
              ))}
            </>
          ) : null}
        </div>
      </div>
    )
  }
)
